import './index.erb';
import './index.rb';

import style from './index.module.scss';
import products from './products';

export const setupProductStep = () => {
  const $elements = products.map(
    (item) => `
  <li
    class="${item.className} q-product-item"
    data-item='${JSON.stringify(item)}'>
    <i class="q-icon ${item.icon}"></i>

    ${item.title}

    <i class="q-icon q-icon-check-circle"></i>
  </li>
`
  );

  $(`.${style.products}`).html($elements.join(''));
};
